class ProductPack extends HTMLElement {
  constructor() {
    super();

    this.jeansPackSize = this.querySelector('jean-pack-size');

    this.tripackdiscount = 0;
    this.sixpackdiscount = 0;
    this.igExecuted = false;
    this.unitOriginalPrice = window.predictProduct.price ? window.predictProduct.price: 0;
    /* const firstVariant = document.getElementById("first_variant").value;
     this.overWriteDiscount(2,9.17,firstVariant, 20);
     this.overWriteDiscount(3, 17.74,firstVariant, 58);*/
   /* window.addEventListener("message", (event) => {
      if (event.data === "ig-ready" && !this.igExecuted) {
        this.updateIntelligencePrices();
        this.evaluateIntelligems();
        this.igExecuted = true;
      }
    }); */


    this.variants_IDs = [];
    this.totalItems = 0;
    this.sidecart = document.querySelector("side-cart");
    this.atcBtn = document.querySelector(".multiple-add-to-cart");
    this.packSizes = document.querySelectorAll(".pack-size__wrapper input");
    this.available = true;

    
    const tags = document.querySelector('variant-radios').dataset.tags;
    if (tags.includes('Mens-tees') || tags.includes('MensTeesCollection') || tags.includes('MensTeesCollection')) {
      this.gender = 'mens';
    } else if (tags.includes('gender_Female') || tags.includes('WomensTeesCollection')) {
      this.gender = 'womens';
    }

    if (window.PacksCore) {
      
      this.packsCore = window.PacksCore;
      this.packsCore.evaluateIntelligems(()=>{
        this.packsCore.updateIntelligencePrices().then(()=>{
          this.changePrice(); 
          this.firstPriceIntelligemsChange(window.predictProduct.variants[0].id);
          this.classList.remove('hidden');
        }); 
      });  
    }

  } 

  evaluateIntelligems() {
    //alert(" IT IS");

    const firstVariant = document.getElementById("first_variant").value;

    const labels1 = document.querySelector('label[for="pack-1"].pack-size');
    const labels2 = document.querySelector('label[for="pack-2"].pack-size');
    const labels3 = document.querySelector('label[for="pack-3"].pack-size');

    let priceUnit = document.querySelector(
      ".price-item.price-item--regular"
    ).textContent;

    //let priceUnitIntIntelligems = window.igData.price.getPriceByVariantId(firstVariant);

    const testObject = window.igData.user.getTestGroup('9a41cffd-832a-4344-8556-59dec3e4c247');

    if (testObject) {

      let priceUnitIntIntelligems = window.igData.price.getPriceByVariantId(firstVariant);
      document.querySelector(".price-item.price-item--regular").innerHTML = `$${priceUnitIntIntelligems}`;
      const { name, isControl } = testObject;

      if (testObject && name.includes('V2')) {

        this.overWriteDiscount(2, 19.767442, firstVariant, null);
        this.overWriteDiscount(3, 25.0645996, firstVariant, null); // 123 * 3 , 
      } else if (testObject && name.includes('V1')) {
        this.overWriteDiscount(2, 16.8067225, firstVariant, null);
        this.overWriteDiscount(3, 24.929972, firstVariant, null);
      } else if (testObject && isControl) {

        this.overWriteDiscount(2, 9.17, firstVariant, 20);
        this.overWriteDiscount(3, 17.74, firstVariant, 58);
      }
    } else {
      this.overWriteDiscount(2, 19.767442, firstVariant, null);
      this.overWriteDiscount(3, 25.0645996, firstVariant, null);
    }

  }

  firstPriceIntelligemsChange(firstVariant) {
    const packs = document.querySelectorAll('.pack-size__wrapper input[type="radio"][name="pack-size"]');
    const selectedPack = document.querySelector('.pack-size__wrapper input[type="radio"][name="pack-size"]:checked');
    const igPrice = window?.igData?.price?.getPriceByVariantId?.(firstVariant);
  
    if (!igPrice || !packs.length || !selectedPack) return;
  
    const currency = window?.theme?.cart_currency_symbol || '$';
  
    // 1) Update "convert each" on every pack option
    packs.forEach((input) => {
      const packSize = Number(input.value);
      const discountPct = Number(input.getAttribute('discount')) || 0;
  
      // Find the label tied to this input
      // Try for= id first (most reliable), fallback to nextElementSibling
      const label =
        document.querySelector(`label[for="${input.id}"]`) ||
        input.nextElementSibling;
  
      if (!label) return;
  
      // If you intended ".convert_each span", keep it like this:
      const convertEachSpan = label.querySelector('.convert_each span');
      const priceEach = Math.ceil(igPrice - (igPrice * discountPct / 100));
  
      if (convertEachSpan) {
        convertEachSpan.textContent = `${currency}${priceEach}`;
      }
    });
  
    // 2) Update the general/current selection price
    const priceFinalEl   = document.querySelector('.price-final');
    const priceDiscountEl= document.querySelector('.price-discount');
  
    const packQty = Number(selectedPack.value) || 1;
    const selDiscountPct = Number(selectedPack.getAttribute('discount')) || 0;
  
    const priceTotal = igPrice * packQty;
    const priceTotalDiscount = priceTotal * (1 - selDiscountPct / 100);
  
    if (priceFinalEl)    priceFinalEl.textContent    = `${currency}${priceTotalDiscount.toFixed(2)}`;
    if (priceDiscountEl) priceDiscountEl.textContent = `${currency}${priceTotal.toFixed(2)}`;
  
    // 3) Dynamically update *all* pack cards in the list (value != "1")
    const dynamicPacks = document.querySelectorAll('.pack-size__list input[type="radio"][name="pack-size"]');
  
    dynamicPacks.forEach((input) => {
      const packQty = Number(input.value);
      if (!packQty || packQty === 1) return; // skip single pack (your "default")
  
      const discountPct = Number(input.getAttribute('discount')) || 0;
  
      const packOg = igPrice * packQty;
      const packDiscount = packOg * (1 - discountPct / 100);
  
      // write attributes so other code can rely on them
      input.setAttribute('pack_og', String(packOg));
      input.setAttribute('pack_price', String(packDiscount));
  
      // Update the visible price block in the label/card for this input
      // Try to find the label tied to this radio
      const label =
        document.querySelector(`label[for="${input.id}"]`) ||
        input.nextElementSibling;
  
      if (!label) return;
  
      // Your markup seems to have a .price container inside that label/card
      const priceContainer = label.querySelector('.price');
      if (priceContainer) {
        priceContainer.innerHTML = `
          <span class="price-final">${currency}${packDiscount.toFixed(2)}</span>
          <small class="price-discount">${currency}${packOg.toFixed(2)}</small>
        `;
      }
    });
  
    // Optional: unit price UI if you need it later
    // const unit = document.querySelector('.unit-wrapper');
    // if (unit) {
    //   unit.classList.remove('hidden');
    //   unit.querySelector('.test-unit-price span').textContent = `${currency}${igPrice}`;
    // }
  }
  


  overWriteDiscount = (packSize, discount, firstVariant, usdSave = null) => {

    let packsInput = document.querySelector(`#pack-${packSize}`);
    if (packsInput) packsInput.setAttribute('discount', discount);

    let labels = document.querySelector(`label[for="pack-${packSize}"].pack-size`);
    let savingsLabel = labels.querySelector('.savings');

    let priceItem = labels.querySelector(".price");
    let priceFinal = labels.querySelector(".price-final");
    let priceDiscount = labels.querySelector(".price-discount");

    let priceTotal = window.igData.price.getPriceByVariantId(firstVariant) * packSize;
    let priceTotalDiscount = priceTotal - (priceTotal * (discount / 100));
    console.log(window.theme);
    if (savingsLabel && !usdSave) savingsLabel.innerHTML = ` ${window.theme.save_text} ${discount.toFixed(0)}% `;
    if (savingsLabel && usdSave) savingsLabel.innerHTML = ` ${window.theme.save_text} $${usdSave} `;
    if (priceFinal) priceFinal.innerHTML = '$' + priceTotalDiscount.toFixed(2);
    priceDiscount.innerHTML = '$' + priceTotal.toFixed(2);
  }



  cleanUrlOnePack() {
    // for for="pack-1"
    const onePack = document.querySelector('label[for="pack-1"].pack-size');
    // on click remove the url query params 
    onePack.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get('bundle');
      if (paramValue) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  }
  setColorByURL() {
    this.cleanUrlOnePack();
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get("bundle");
    const setParam = urlParams.get("color");
    if (paramValue) {
      this.packSizes.forEach((ps) => {
        console.log(`${paramValue} - ${ps.id}`);
        if (ps.id == paramValue) {
          ps.click();
        }
      });
    }
    console.log("setparam " + setParam);
    if (setParam != null) {
      console.log("color bundle clicked");
      this.querySelector(`#${setParam}`).click();
    }
    console.log(paramValue);
  }

  connectedCallback() {
    console.log(window.bundleVariants);
    let sizes = this.querySelectorAll(".size-variants__wrapper input");
    let unitSizes = document.querySelectorAll(
      'variant-radios fieldset[data-option-name="Size"] input'
    );
    let colorSets = this.querySelectorAll(".color-set__wrapper input");
    this.atcBtn.addEventListener("click", () => {
      this.multipleAddToCart();
    });
    sizes.forEach((size) => {
      size.addEventListener("click", () => {
        this.pickSize();
      });
    });
    unitSizes.forEach((size) => {
      size.addEventListener("click", () => {
        //this.querySelector(`.size-variants__wrapper input[value="${size.value}"]`).checked = true;
        //this.querySelector('.pack-size__wrapper input[value="1"]').click();
      });
    });
    colorSets.forEach((colorSet) => {
      colorSet.addEventListener("click", () => {
        this.pickSize();
      });
    });
    this.packSizes.forEach((pk) => {
      pk.addEventListener("click", () => {
        this.changePackSize();
      });
    });
    this.changePackSize();
    this.pickSize();
  }

  disconnectedCallback() { }

  static get observedAttributes() {
    return [
      /* array of attribute names to monitor for changes */
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // called when one of attributes listed above is modified
  }

  async pickSize() {
    this.querySelector(".addtocart-error").style.display = "none";
    this.available = true;
    this.totalItems = 0;
    this.variants_IDs = [];
    let colorHeader = this.querySelector(".color_picker-header p span");
    let color = document.querySelector(".color-set__wrapper input:checked");

    if (this.jeansPackSize && this.jeansPackSize.setSelectedColorSet && color) await this.jeansPackSize.setSelectedColorSet(color);
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let opts = document.querySelectorAll(
      ".color-set__wrapper input:checked + label .variant__size"
    );
    let checkedOpt = document.querySelector(
      ".size-variants__wrapper input:checked"
    );
    console.info(checkedOpt);
    /*let notCheckedOpt = document.querySelectorAll('.size-variants__wrapper input');
      if(checkedOpt.disabled) {disc

      }
      notCheckedOpt.forEach((ntc, index) => {
          if(ntc.checked) {
              if(ntc.disabled) {
                  if(notCheckedOpt[index+1].disabled == false) {
                      notCheckedOpt[index+1].click();
                  }
              }
          }
        });*/
    let dummyWrapper = document.querySelector("#dummyPack");
    if (color) dummyWrapper.value = color.getAttribute("dummy");
    let grandParent = color.getAttribute("grand-parent-id");
    if ( grandParent ) {
      this._grandparent_id = color.getAttribute("grand-parent-id");
      this._grand_parent_title = color.getAttribute("grand-parent-title");
    }
    if (checkedOpt) {
      let itemsAdded = true;
      opts.forEach((opt) => {
        if (checkedOpt.value.toLowerCase() == opt.getAttribute("size")) {
          //console.log(color.value);
          //console.log(opt.getAttribute("item-qty"));
          this.variants_IDs.push(opt);
          console.log("opt: ", opt);

          this.va;
          this.totalItems =
            this.totalItems + Number(opt.getAttribute("item-qty"));
          if (opt.getAttribute("quantity") < 5) {
            itemsAdded = false;
            this.available = false;
          }
        }
      });

      colorHeader.innerHTML = "";
      if (itemsAdded) {
        console.log(this.totalItems);
        //this.atcBtn.classList.remove("disabled-error");
        //this.atcBtn.classList.remove('disabled');
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      } else {
        console.log("here");
        this.atcBtn.classList.add("disabled-error");
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      }
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      console.log(activeColors);
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      } else {
        colorHeader.innerHTML = "-";
        this.querySelector(".size-variants__wrapper").classList.add("disabled");
        this.querySelector(".msg__error").classList.remove("hidden");
        //this.variants_IDs = [];
        this.atcBtn.classList.add("disabled");
        this.atcBtn.innerHTML = "sold out";
        this.changePrice();
      }
    } else {
      this.atcBtn.classList.remove("disabled");
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      colorHeader.innerHTML = "";
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      }
      this.atcBtn.innerHTML = window.theme.add_to_cart;
    }
    if (this.querySelector(".size-variants__wrapper input:checked")) {
      if (
        this.querySelector(".size-variants__wrapper input:checked").disabled
      ) {
        this.atcBtn.innerHTML = "Sold out";
        this.atcBtn.classList.add("disabled");
      } else {
        this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
        this.atcBtn.classList.remove("disabled");
      }
    }
    window.PacksCore.setUrlByColor(color.getAttribute('id'), packSize.value);
    this.createSliderImage();
    this.changePrice();
  }

  async multipleAddToCart() {
    console.log(this.variants_IDs);
    if (
      !this.atcBtn.classList.contains("disabled-error") &&
      this.querySelector(".msg__error").classList.contains("hidden")
    ) {
      this.atcBtn.classList.add("loading");
      let packSize = this.querySelector(".pack-size__wrapper input:checked");
      let dummyProps = "";
      let packDiscount = 0;
      let packPrice = 0;
      let productSize = this.querySelector(
        ".size-variants__wrapper input:checked"
      ).value;
      this.variants_IDs.forEach((VId) => {
        if (dummyProps != "") {
          dummyProps += " / " + VId.getAttribute("color");
        } else {
          dummyProps += VId.getAttribute("color");
        }
        //console.log('intelli price',window.igData.price.getPriceByVariantId(VId.id));
        let subtotal =
          Number(VId.getAttribute("price")) *
          Number(VId.getAttribute("item-qty"));

        packDiscount += subtotal;

      });
      let originalPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * Number(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;

      if (this.available) {
        let bundleIndex = Date.now();
        let all_items = this.sidecart.querySelectorAll(".sidecart__item");
        all_items.forEach((item) => {
          if (item.getAttribute("bundleindex")) {
            bundleIndex++;
          }
        });
        console.log(bundleIndex);
        let updates = {
          items: [],
        };
        let dummyPack = {
          id: this.querySelector("#dummyPack").value,
          quantity: 1,
          properties: {
            dummyPack: true,
            bundle_index: bundleIndex,
            innerItems: dummyProps,
            ogp: `${originalPrice} - ${packPrice}`,
            packSize: packSize.value,
            originalprice: `${originalPrice}`,
            packPrice: packPrice,
            prodSize: `${this.jeansPackSize.defaultSelected.waist}x${this.jeansPackSize.defaultSelected.inseam}`,
          },
        };
        
        let thisDiscount = packSize.getAttribute("discount");
        let totalBckpPrice = 0;
        let igPlusDiscount = null;
        this.variants_IDs.forEach((variantID) => {
          let thisID = variantID.getAttribute("id");
          let thisQty = variantID.getAttribute("item-qty");
          const price = variantID.getAttribute("price") - (variantID.getAttribute("price") * thisDiscount / 100);
          const discountedPrice = (price % 1 !== 0) ? price.toFixed(2) : price.toFixed(0);
          const originalItemPrice = (variantID.getAttribute("price") / 100) ;
          const discountedItemPrice = originalItemPrice - (originalItemPrice * thisDiscount / 100);
          const packOriginalPrice = (Number(packSize.value) * this.unitOriginalPrice) / 100;
          const bckpPrice = variantID.getAttribute("bckp-pc")? Number(variantID.getAttribute("bckp-pc")) / 100 : 0;
          totalBckpPrice += bckpPrice * Number(thisQty);
          let obj = {
            id: thisID,
            quantity: Number(thisQty),
            properties: {
              _bundle_index: bundleIndex,
              _teepack: true,
              _discount: thisDiscount,
              _parent_id: dummyPack.id,
              _original_price: originalPrice,
              _total_price: packPrice,
              _parent_name: this._grand_parent_title,
              _parent_name: this._grand_parent_title,
              'Original price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(originalItemPrice)}`,
              'Discounted price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(discountedItemPrice)}`
            },
          };
          if (this._grandparent_id != null) {
            obj.properties._grandparent_id = this._grandparent_id;
          }
          updates.items.push(obj);
        });
        //updates.items.push(dummyPack);
        const totalPackPrice = (packPrice / 100).toFixed(2);
        console.log('totalPackPrice', totalPackPrice);
        const realTotalDiscount = (1 - (totalPackPrice / totalBckpPrice)) * 100;
        console.log('realTotalDiscount', realTotalDiscount.toFixed(2));
        debugger;
        if (realTotalDiscount.toFixed(2) != Number(thisDiscount).toFixed(2) && totalBckpPrice > 0) {
          igPlusDiscount = (realTotalDiscount - thisDiscount);
          igPlusDiscount = (igPlusDiscount % 1 === 0)? igPlusDiscount.toFixed(2) : igPlusDiscount; 
          igPlusDiscount = `igd${igPlusDiscount}data`;
          updates.items.forEach(item => {
            item.properties._ig_data_v = igPlusDiscount;
          });
        }
        console.log(updates);
        const properties = {
          ...fetchConfig("javascript"),
          body: JSON.stringify(updates),
        };
        console.log(properties);
        try {
          const response = await fetch("/cart/add.js", properties);
          const data = await response.json();

          // get the cart data and then render on the side cart
          this.atcBtn.classList.remove("loading");

          if (response.ok) {
            this.sidecart.getCart();
            this.sidecart.openCart();
          } else {
            if (window.AddResponseHandler) {
              window.AddResponseHandler.handleCartAddError(updates, response, data, null, 'bundle_add');
            }
          }

        } catch (err) {
          console.error(err);
          
          if (window.AddResponseHandler) {
            window.AddResponseHandler.handleCartAddError(updates, null, null, err, 'bundle_add');
          }
        }
      }
    } else {
      this.querySelector(".addtocart-error").style.display = "block";
    }
  }

  changeIcon(fit) {
    if (this.gender == 'mens' && fit == 'curved') fit = 'crew';

    if (document.querySelector('.title').innerText.includes('LONG SLEEVE')) {

      fit = fit + '-long-sleeve';
      console.log(fit);
    }
    const tags = document.querySelector('variant-radios').dataset.tags;

    let icons = document.getElementById('tees-icons');

    let iconsCurrent = [...icons.querySelectorAll(`option[fit="${fit}"][gender="${this.gender}"]`)];

    // mean while we have not curved mens



    iconsCurrent.forEach((iconCurrent) => {
      const icon = iconCurrent.value;
      const pack = iconCurrent.getAttribute('pack');
      const label = document.querySelector(`label.pack-size[for="${pack}"]`);
      //label.style.backgroundImage = `url(${icon})`;
      if (label) label.querySelector('img').src = icon;
    });

    // every iconCurrent is a option that has as value the icon image who must to be displayed at the label.pack-size where the fit is selected and the attr of the label [for] must be equal to the option  attribute [pack]


  }
  pickFit(fit) {
    if(fit) {
      const fitWOSpace = fit.replace(/\s/g, '');
      this.changeIcon(fitWOSpace);
      
    } 
    let items = document.querySelectorAll(".product-fit__choice");
    let packSize = this.querySelector(".pack-size__list input:checked");
    let wrappers = this.querySelectorAll(".color-set__wrapper"); 
    let colorHeader = this.querySelector(".color_picker-header p span");
    colorHeader.innerHTML = "-";
    this.querySelector(".size-variants__wrapper").classList.add("disabled");
    this.querySelector(".msg__error").classList.remove("hidden");
    //this.atcBtn.classList.add('disabled');
    if (packSize.value != 1) {
      //packSize.nextElementSibling.querySelector('.price').innerHTML = '-';
    }
    //this.variants_IDs = [];
    //this.atcBtn.classList.add('disabled');
    this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
    wrappers.forEach((wrapper) => {
      wrapper.classList.add("hidden");
    });
    wrappers.forEach((wrapper) => {
      items.forEach((item) => {
        if (item.classList.contains("fit-active")) {
          if (wrapper.getAttribute("fit") == item.getAttribute("data-fit")) {
            if (wrapper.getAttribute("pack-size") == packSize.value) {
              wrapper.classList.remove("hidden");
              wrapper.querySelector("input").checked = true;
              this.pickSize();
            }
          }
        }
      });
    });
    this.createSliderImage()
    fontResize();
    this.changePrice();
  }

  changePrice() {
    console.log("changePrice called");
    let atc = this.querySelector(".multiple-add-to-cart");
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let packDiscount = 0;
    let unitPrice = document.querySelector(".unit__price");
    let packPrice = 0;
    let titlePrice = document.querySelector(".pack-title__price");
    let packEach = document.querySelector(`.convert_each span[data-unit="${packSize.value}"]`);
    let ogPrice = 0;
    console.log(this.variants_IDs);
    
    if (this.variants_IDs.length != 0) {
      
      this.variants_IDs.forEach((VId) => {
        console.log("VId", VId);
        const itemPrice = VId.getAttribute("price") / 100;
        const itemQty = VId.getAttribute("item-qty");
       
        let subtotal =
          Number(itemPrice  ) *
          Number(itemQty);
        packDiscount += subtotal;
      });
      ogPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * Number(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;
    }

    let priceItem = packSize.nextElementSibling;
    console.log('priceItem', priceItem);
    priceItem = priceItem.querySelector(".price");
    if (packSize.value != 1) {
      if (packPrice == 0) {
        //priceItem.innerHTML = `-`;
        atc.innerHTML = window.theme.add_to_cart;
      } else {
        priceItem.innerHTML = `${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(packPrice)} <small>${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(ogPrice)}</small>`;
        //packEach.innerHTML = Math.ceil(Shopify.formatMoneyAmmount(packPrice) / parseInt(packSize.value));
        //atc.innerHTML = 'add to cart';
      }
      unitPrice.classList.add("hidden");
      titlePrice.classList.remove("hidden");
    } else {
      
      unitPrice.classList.remove("hidden");
      titlePrice.classList.add("hidden");
    }
    const clonedPriceItem = priceItem.cloneNode(true);
    const priceFinal = clonedPriceItem.querySelector('.price-final');
    const priceDiscount = clonedPriceItem.querySelector('.price-discount');

    if (priceFinal && priceDiscount) {
        priceFinal.innerHTML = priceFinal.innerHTML + ` ${window.theme.shop_currency}`;
        priceDiscount.innerHTML = priceDiscount.innerHTML + ` ${window.theme.shop_currency}`;
    } else {
        clonedPriceItem.innerHTML = `${window.theme.cart_currency_symbol}${packPrice.toFixed(2)} ${window.theme.shop_currency} <small>${window.theme.cart_currency_symbol}${ogPrice} ${window.theme.shop_currency}</small>`;
    }
    titlePrice.innerHTML = clonedPriceItem.innerHTML;
    fontResize();
  }

  changePackSize() {
    let wrapper = document.querySelector(".product-pack__content");
    let unitEls = {
      vr: document.querySelector("variant-radios"),
      vrSW: document.getElementById("variant-radios-single-wrapper"),
      fcp: document.querySelector("fit-color-picker .product-color_picker"),
      pf: document.querySelector(".product-buy-buttons"),
      vrsg: document.querySelector(".variant-radios__size-guide"),
    };
    let checkedOpt = this.querySelector(".pack-size__wrapper input:checked");
    console.log(checkedOpt.value);
    if (checkedOpt.value == 1) {
      wrapper.classList.add("hidden");
      unitEls.vr.classList.remove("hidden");
      unitEls.vrSW.classList.remove("hidden");
      unitEls.fcp.classList.remove("hidden");
      unitEls.pf.classList.remove("hidden");
      unitEls.vrsg.classList.remove("hidden");
      let unitChecked = document.querySelector(
        `variant-radios fieldset[data-option-name="Size"] input:checked`
      );
      if (unitChecked) {
        unitChecked.checked = false;
        unitChecked.click();
      } else {
        let packChecked = this.querySelector(
          ".size-variants__wrapper input:checked"
        );
        if (packChecked) {
          console.log(packChecked.value);
          const selectedWaist = this.jeansPackSize.defaultSelected.waist;
          const selectedInseam = this.jeansPackSize.defaultSelected.inseam;

          if (selectedWaist) document.querySelector(`variant-radios fieldset[data-option-name="Waist"] input[value="${selectedWaist}"]`).click();
          if (selectedInseam) document.querySelector(`variant-radios fieldset[data-option-name="Inseam"] input[value="${selectedInseam}"]`).click();

        }
      }
      if (document.querySelector('.seasonal-colors-container') && document.querySelector('.seasonal-colors-container').innerHTML.trim() !== '') {
        document.querySelector('.seasonal-color_picker')?.classList.remove('hidden');
      }
    } else {

      let unitSize = document.querySelector(
        'variant-radios fieldset[data-option-name="Size"] input:checked'
      );
      let sizes = this.querySelectorAll(".size-variants__wrapper input");
      if (unitSize) {
        unitSize.checked = false;
        sizes.forEach((size) => {
          if (size.value == unitSize.value) {
            size.checked = true;
          }
        });
      }
      wrapper.classList.remove("hidden");
      unitEls.vr.classList.add("hidden");
      unitEls.vrSW.classList.add("hidden");
      unitEls.fcp.classList.add("hidden");
      unitEls.pf.classList.add("hidden");
      unitEls.vrsg.classList.add("hidden");
      this.jeansPackSize.setSelectedPackAndColor(checkedOpt.value);
      if (document.querySelector('.seasonal-colors-container')) {
        document.querySelector('.seasonal-color_picker')?.classList.add('hidden');
      }
    }
    this.pickFit();
  }


  createSliderImage() {
    //return;
    let bundleImg = document.querySelector(
      '.product-images-container .swiper-slide[data-swiper-slide-index="0"] img'
    );
    let bundleImgDup = document.querySelector(
      '.product-images-container .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let bundleDot = document.querySelectorAll(
      ".product-images-container .swiper-pagination .swiper-pagination-bullet img"
    );
    let color = document.querySelector(
      ".color-set__wrapper:not(.hidden) input:checked"
    );
    let modalImg = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide[data-swiper-slide-index="0"] img'
    );
    let modalImgDup = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let packSize = this.querySelector(".pack-size__list input:checked");
    if (packSize.value != 1) {
      if (color) {
        console.log("bundle");
        bundleImg.src = color.getAttribute("img");
        bundleImgDup.src = color.getAttribute("img");
        modalImg.src = color.getAttribute("img");
        modalImgDup.src = color.getAttribute("img");
        if (window.innerWidth >= 750) {
          bundleDot[0].src = color.getAttribute("img");
        }
        let bullet = document.querySelector(
          ".swiper-pagination .swiper-pagination-bullet"
        );
        bullet.click();
      }
    } else {
      console.log("original");
      bundleImg.src = bundleImg.getAttribute("original");
      bundleImgDup.src = bundleImg.getAttribute("original");
      modalImg.src = bundleImg.getAttribute("original");
      modalImgDup.src = bundleImg.getAttribute("original");
      if (window.innerWidth >= 750) {
        bundleDot[0].src = bundleImg.getAttribute("original");
      }
    }
  }
}

customElements.define("product-pack", ProductPack);